__turbopack_context__.v({
  "heartIcon": "AthleteFanAction-module-scss-module__0tugZq__heartIcon",
  "trigger": "AthleteFanAction-module-scss-module__0tugZq__trigger",
});
